// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"474":"eaf6a9ce","696":"8f1b70fa","959":"370cd317"}[chunkId] + ".css";
};